document.addEventListener('DOMContentLoaded', function () {
  const initRelatedSwiper = () => {
    if (typeof Swiper === 'undefined') {
      setTimeout(initRelatedSwiper, 100);
      return;
    }
    document.querySelectorAll('[data-related-swiper]').forEach(function (wrapper) {
      var id = wrapper.dataset.relatedSwiper;
      new Swiper('.related-swiper-' + id, {
        slidesPerView: 2.5,
        spaceBetween: 8,
        pagination: {
          el: wrapper.querySelector('.related-pagination'),
          clickable: true,
        },
        mousewheel: {
          forceToAxis: true,
        },
        breakpoints: {
          300: { slidesPerView: 1.5, spaceBetween: 8 },
          640: { slidesPerView: 2.5, spaceBetween: 12 },
        }
      });
    });
  };
  initRelatedSwiper();
});
